import './cards.css'
import React, {useEffect, useState} from "react";
import CustomAlert from "../common/CustomAlert";
import {Link} from "react-router-dom";


function CardLatest({item}){



    let imageUri;

    if (item.image?.path) {
        imageUri = `https://www.mnfansubs.net/resource/${item.image?.path}`;
    }  else if (item.image) {
        imageUri = `https://www.mnfansubs.net/resource/${item.image?.name}_s.${item.image?.ext}`;
    } else {
        imageUri = ''
    }


    return(
        <>
            <div>
                <div className="cart-latest">
                    <div className="ep-number">
                        <div>
                            {item.episodeNumber}-р анги
                        </div>
                    </div>
                    <div className="img">
                        <img src={imageUri} alt=""/>
                    </div>
                    <Link to={`/player/episode/${item.id}`}
                        className="wrapper"
                    >
                        <div className="content">
                            <div className="title">
                                <span>
                                    {item.movie.name}
                                </span>
                            </div>
                            <div className="duration">
                                <div>
                                    {item.duration}
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="cart-latest-mobile">
                    <div className="ep-number">
                        {item.episodeNumber}-р анги
                    </div>
                    <Link to={`/player/episode/${item.id}`}>
                        <div className="img">
                            <img src={`https://www.mnfansubs.net/resource/${item.image?.name}.${item.image?.ext}`} alt=""/>
                        </div>
                        <div className="title">{item.name}</div>
                    </Link>
                    <div className="duration">{item.duration}</div>
                </div>
            </div>
        </>

    )

}

export default CardLatest
